module.exports = __webpack_public_path__ + "post-listing-cross-promotoe-ico-3@2x-1ZLA45F.png";